import "jquery";
import * as ko from "knockout";
import { BaseCropComponent } from "./BaseCropComponent";
import { OsrSamplesGroupByCropNumber } from "../Models/Osr/OsrSamplesGroupByCropNumber";

export class OsrSamples extends BaseCropComponent<OsrSamplesGroupByCropNumber> {
    constructor() {
        super($('#osrsamples-table'));
    }
    init(): void {
        this.osrApi.getSamples().then((res) => {
            super.init(res, "cropNo", '*[data-bind="text: sampleCrop.CropNumber"]');
        });
    }
}